import React from "react";

const SplashScreen = () => {
  return (
    <>
      <div className="splashBody">
        <div className="splashScreen">
        <div className="loader1"></div>
        </div>
      </div>

    
    </>
  );
};
export default SplashScreen;
